import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AdminNavbar from "./AdminNavbar";

const API_URL = process.env.REACT_APP_API_URL;

export default function ManageArticles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await fetch(`${API_URL}/api/articles`);
      const data = await res.json();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (name) => {
    const ok = await Swal.fire({
      icon: "warning",
      title: "Delete this article?",
      text: "This cannot be undone.",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#DC2626",
    });
    if (!ok.isConfirmed) return;

    try {
      const res = await fetch(
        `${API_URL}/api/articles/${encodeURIComponent(name)}`,
        { method: "DELETE" }
      );
      if (!res.ok) throw new Error();
      setItems(items.filter((i) => i.name !== name));
      Swal.fire({ icon: "success", title: "Deleted.", confirmButtonColor: "#DC2626" });
    } catch {
      Swal.fire({ icon: "error", title: "Delete failed", confirmButtonColor: "#DC2626" });
    }
  };

  return (
    <div className="admin-shell">
      <AdminNavbar />

      <div className="admin-page">
        <div className="admin-head">
          <div>
            <p className="eyebrow">Library</p>
            <h1>Manage <em>articles</em>.</h1>
          </div>
          <Link to="/CreateArticle" className="btn-new">New Article</Link>
        </div>

        {loading ? (
          <div className="loader-wrap"><div className="loader" /></div>
        ) : items.length === 0 ? (
          <p className="empty-state">No articles yet — write your first one.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Thumb</th>
                <th>Date</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a._id}>
                  <td style={{ fontWeight: 500 }}>{a.name}</td>
                  <td>{a.thumbnail && <img src={a.thumbnail} alt="" />}</td>
                  <td>{new Date(a.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</td>
                  <td style={{ textAlign: "right" }}>
                    <Link
                      to={`/articles/${encodeURIComponent(a.name)}`}
                      className="btn-outline"
                      style={{ padding: "0.45rem 0.95rem", fontSize: "0.72rem", marginRight: "0.5rem" }}
                    >
                      View
                    </Link>
                    <Link
                      to={`/EditArticle/${encodeURIComponent(a.name)}`}
                      className="btn-outline"
                      style={{ padding: "0.45rem 0.95rem", fontSize: "0.72rem", marginRight: "0.5rem" }}
                    >
                      Edit
                    </Link>
                    <button className="btn-delete" onClick={() => handleDelete(a.name)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
